<template>
  <div class="work-package-widget-list">
    <RadioButtonSquare
      v-for="(widget, index) in widgets"
      :key="`${widget.step_name}${index}`"
      :id="`${widget.text}${index}`"
      :is_active="is_active(widget)"
      :is_badge="widget.is_badge"
      :items_per_row="items_per_row"
      :badge_width="16"
      :background_color="background_color"
      :foreground_color="foreground_color"
      :is_disabled="widget.disabled"
      @setActive="$emit('setActive', widget)"
    >
      <template #badge>
        <TText
          v-if="widget.is_badge"
          :text="widget.badge_info"
          :color="foreground_color"
          :size="8"
        />
      </template>
      <template #content>
        <TTooltip :value="widget.tooltip">
          <div class="work-package-widget-list-content">
            <TIcon
              :name="widget.icon"
              style="transition: none"
              :large="!is_small_icons"
            />
            <TText
              :value="widget.text"
              :color="is_active(widget)
                ? background_color
                : foreground_color"
              :size="8"
            />
          </div>
        </TTooltip>
      </template>
    </RadioButtonSquare>
  </div>
</template>

<script>
import RadioButtonSquare from '@/components/WorkPackageWIP/RadioButtonSquare.component.vue';
import TText from '@/components/Taktify/TText.component.vue';
import TIcon from '@/components/Taktify/TIcon.component.vue';
import TTooltip from '@/components/Taktify/TTooltip.component.vue';

  export default {
    components: {
      RadioButtonSquare,
      TText,
      TIcon,
      TTooltip,
    },

    props: [
      'widgets', // is array of objects, contains icon, text (string) - necessary and is_badge (boolean), badge_info (string) - optional
      'is_small_icons', // is boolean, toggles use of smaller icons
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
      'items_per_row'
    ],

    computed: {
    },

    data: () => ({
    }),
    methods: {
      is_active(widget){
        // NOTE: a better solution is welcomed
        return this.$route.name.includes(widget.route_name) && !this.$route.path.includes('step');
      },
    },

  }
</script>

<style>
  .work-package-widget-list {
    margin: 5px 0;
    display: flex;
    flex-direction: row;
    grid-gap: 8px;
    flex-wrap: wrap;
  }
  .work-package-widget-list-content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
</style>
